module.exports = __webpack_public_path__ + "assets/microsoft-365.2714a309.svg";